var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsi = function SvgNotificationsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m19.878 16.844-1.7-2.7V9.557A6.385 6.385 0 0 0 12 3a6.385 6.385 0 0 0-6.182 6.557v4.588l-1.7 2.7a.812.812 0 0 0-.036.792.724.724 0 0 0 .641.407h3.751A3.687 3.687 0 0 0 12 21a3.687 3.687 0 0 0 3.526-2.957h3.747a.724.724 0 0 0 .641-.407.812.812 0 0 0-.036-.792zM12 19.457a2.188 2.188 0 0 1-2.01-1.414h4.02A2.188 2.188 0 0 1 12 19.457zM6.086 16.5l1.065-1.694a.807.807 0 0 0 .122-.427V9.557A4.882 4.882 0 0 1 12 4.543a4.882 4.882 0 0 1 4.727 5.014v4.822a.807.807 0 0 0 .122.427l1.065 1.694z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsi);
export default ForwardRef;